import { Component, type OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { isNil } from 'lodash-es';
import { Subscription, filter, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-redirector',
  standalone: true,
  template: ``
})
export class RedirectorComponent implements OnDestroy {
  readonly #sub: Subscription;
  constructor(svc: AuthService, router: Router) {
    this.#sub = svc
      .isLogged()
      .pipe(
        switchMap(a => (isNil(a) ? svc.requestLogin() : of(a))),
        map(a => a?.roles),
        filter(Array.isArray)
      )
      .subscribe(a => {
        if (a.includes('Customer')) router.navigate(['/customer']);
        else router.navigate(['/anagrafiche']);
      });
  }
  ngOnDestroy() {
    this.#sub.unsubscribe();
  }
}
